import React, { useState, useEffect } from "react";
import {
  Box,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Icon,
  SimpleGrid,
  Td,
  Button,
  Stack,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import Modal_Pay_student from "./AdminStudentPay/Modal_Pay_student";
import {
  FaUser,
  FaBook,
  FaList,
  FaCalendarAlt,
  FaMoneyBillAlt,
} from "react-icons/fa";
import { ACCOUNTS_URL, BASE_URL } from "../../../../Globalapi/Globalapi";

const Return = () => {
  const toast = useToast();
  const [selectedBook, setSelectedBook] = useState(null);
  const [assignedStudent, setAssignedStudent] = useState(null);
  const [returnedBooks, setReturnedBooks] = useState([]); // Tracks returned books
  const [books, setBooks] = useState([]); // Books list from API
  const [categories, setCategories] = useState([]); // Categories list from API
  const [selectedCategory, setSelectedCategory] = useState(""); // Selected category filter
  const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [bookIssues, setBookIssues] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenn, setIsModalOpenn] = useState(false);

  const [selectedIssue, setSelectedIssue] = useState(null);
  const [paymentType, setPaymentType] = useState("");
  const [fineAmount, setFineAmount] = useState(0); // Track fine amount
  const [ledgerId, setLedgerId] = useState(null); // State for storing the ledgerId
  const [payFee, setPayFee] = useState([]);

  const [formData, setFormData] = useState({
    feesGroup: "",
    feesType: "",
    amount: "",
    collectionDate: "2025-01-03",
    paymentReference: "",
    status: false,
    notes: "",
    selectedFees: [],
  });
  const schoolId = sessionStorage.getItem("school_id");

  useEffect(() => {
    fetchBooks();
    fetchCategories();
    fetchBookIssues();
  }, []);

  const fetchBooks = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/library/books/list_books.php?school_id=${schoolId}`
      );
      const data = await response.json();
      if (data.success) {
        setBooks(data.data);
      } else {
        console.error("Failed to fetch books:", data.message);
      }
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/library/category/list_category.php?school_id=${schoolId}`
      );
      const data = await response.json();
      if (data.success) {
        setCategories(data.data);
      } else {
        console.error("Failed to fetch categories:", data.message);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchBookIssues = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/library/issues/list_issue.php?school_id=${schoolId}`
      );
      console.log("list issuess return admin", response);

      if (response.data.success) {
        // Filter the issues to include only those with status "Issued"
        const issuedIssues = response.data.data.filter(
          (issue) => issue.status === "Issued"
        );
        setBookIssues(issuedIssues);
        // setBookIssues(response.data.data);
      } else {
        console.error("Failed to fetch book issues:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching book issues:", error);
    }
  };

  const handleBookSelect = (event) => {
    const bookId = event.target.value;
    const book = books.find((b) => b.id === parseInt(bookId));
    setSelectedBook(book);
  };

  const handleOpenModal = (issue) => {
    setSelectedIssue(issue);
    setFineAmount(issue.is_fine === 0 ? 0 : issue.fine_amount); // Set fine amount
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedIssue(null);
  };

  const handleReturnBook = async () => {
    const requestData = {
      user_id: sessionStorage.getItem("user_id"), // Ensure you have the user ID in sessionStorage
      school_id: schoolId, // You already have this value in state
      book_id: selectedIssue.book_id, // From the selected book issue
      member_id: selectedIssue.member_id, // Assuming member can be a student or teacher
      book_issue_id: selectedIssue.id, // Issue ID
      return_date: new Date().toISOString().split("T")[0], // Format date to 'YYYY-MM-DD'
    };
    console.log("retunnrnn", requestData);

    try {
      const response = await axios.post(
        `${BASE_URL}/admin/library/issues/return.php`,
        requestData
      );
      console.log("reeqqqii return", response);

      if (response.data.success) {
        // Handle success
        toast({
          title: "Success",
          description: response.data.message,
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // Update the list of returned books or refresh the list of book issues
        setReturnedBooks((prevState) => [
          ...prevState,
          { ...selectedIssue, return_date: requestData.return_date }, // Add the returned book to list
        ]);

        // If there's a fine, show additional information
        if (response.data.data.fineAmount > 0) {
          toast({
            title: "Fine Amount",
            description: `You have a fine of ${response.data.data.fineAmount}`,
            status: "warning",
            duration: 3000,
            isClosable: true,
          });
        }

        // Close the modal and reset selected issue
        handleCloseModal();
      } else {
        toast({
          title: "Error",
          description: response.data.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error returning book:", error);
      toast({
        title: "Error",
        description: "An error occurred while returning the book.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const Return = () => {
    handleReturnBook();
  };

  // Filter issues by selected book if any
  const filteredIssues = selectedBook
    ? bookIssues.filter((issue) => issue.book_id === selectedBook.id)
    : bookIssues;

  const totalPages = Math.ceil(filteredIssues.length / rowsPerPage);
  const currentData = filteredIssues.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  console.log("current data", currentData);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when rows per page is changed
  };

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      const userId = sessionStorage.getItem("cmp_id");

      try {
        let cashLedgerId, bankLedgerId;

        if (formData.paymentType === "1") {
          // No need to call any additional API for Cash
          const response = await axios.post(
            `${ACCOUNTS_URL}/common/get_default_cash.php`,
            {
              cmp_id: userId, // Pass the user_id here
            }
          );
          console.log("====================================");
          console.log(response);
          console.log("====================================");
          const cashLedger = response.data.data[0];

          cashLedgerId = cashLedger.ledg_id; // You can hardcode or retrieve it elsewhere if needed
          setLedgerId(cashLedgerId);
        } else if (formData.paymentType === "2") {
          // Fetch bank ledger ID with POST request
          const responseBank = await axios.post(
            `${ACCOUNTS_URL}/common/get_default_bank.php`,
            {
              cmp_id: userId, // Pass the user_id here
            }
          );
          console.log("====================================");
          console.log(responseBank);
          console.log("====================================");
          const bankLedger = responseBank.data.data[0];
          bankLedgerId = bankLedger.ledg_id; // Extract the ledger_id
          setLedgerId(bankLedgerId);
          if (responseBank.data.status === "success") {
            const bankLedger = responseBank.data.data[0];
            bankLedgerId = bankLedger.ledg_id; // Extract the ledger_id
            setLedgerId(bankLedgerId);
          } else {
            toast({
              title: "Error",
              description: "Failed to fetch bank ledger ID.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          }
        }
      } catch (err) {
        toast({
          title: "Error",
          description: "An error occurred while fetching payment methods.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    // Fetch payment method related data and ledger ID
    fetchPaymentMethods();
  }, [formData.paymentType, toast]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleOpenModall = () => {
    setIsModalOpenn(true);
  };

  const handleCloseModall = () => {
    setIsModalOpenn(false);
    // setSelectedIssue(null);
  };

  return (
    <Box>
      {/* <Flex
        align="center"
        direction={{ base: "column", md: "row" }}
        spacing={5}
        className="sb"
        p={3}
        // mb={1}
      >
        <Flex justify="space-between">
          <Select
            // width="120px"
            width={{ base: "280px", md: "120px" }}
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={75}>75</option>
          </Select>
        </Flex>
        <Flex justify="flex-end" width="100%">
          <Box
            width={{ base: "100%", md: "70%" }}
            mt={{ base: 2, md: 0 }} // Margin top 2 for small screens, no margin for larger screens
          >
            <Select
              placeholder="Select a book"
              onChange={handleBookSelect}
              value={selectedBook?.id || ""}
              // width="200px"
              width={{ base: "100%", md: "250px" }} // Full width on small screens, fixed width on large screens
              borderColor="#E9EDF4"
            >
              <option value="">All Books</option>
              {books.map((book) => (
                <option key={book.id} value={book.id}>
                  {book.title}
                </option>
              ))}
            </Select>
          </Box>
        </Flex>
      </Flex> */}

      <Flex
        // Outer container settings
        align="center"
        direction={{ base: "column", md: "row" }}
        justify="space-between" // Use space-between to push children to the ends
        p={3}
        width="100%" // Ensure it takes full width of its parent
        gap={{ base: 3, md: 5 }}
        borderRadius="lg"
        shadow="lg  "
      >
        {/* Left Section: Rows Per Page Select */}
        <Flex
          justify={{ base: "space-between", md: "flex-start" }}
          width={{ base: "100%", md: "auto" }} // Full width on mobile, auto on desktop
          align="center"
        >
          <Text mr={2} display={{ base: "block", md: "none" }}>
            Rows Per Page
          </Text>
          <Select
            width={{ base: "100%", md: "120px" }} // Full width on mobile
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={75}>75</option>
          </Select>
        </Flex>

        {/* Right Section: Select Book Dropdown */}
        <Flex
          justify={{ base: "flex-start", md: "flex-end" }} // Align to the end on desktop
          width={{ base: "100%", md: "auto" }} // Full width on mobile, auto on desktop
        >
          <Select
            placeholder="Select a book"
            onChange={handleBookSelect}
            value={selectedBook?.id || ""}
            width={{ base: "100%", md: "250px" }} // Full width on mobile, fixed width on desktop
            borderColor="#E9EDF4"
          >
            <option value="">All Books</option>
            {/* Assuming 'books' is defined in the component's scope */}
            {books.map((book) => (
              <option key={book.id} value={book.id}>
                {book.title}
              </option>
            ))}
          </Select>
        </Flex>
      </Flex>

      <Box>
        <Box overflowX="auto" maxWidth="100%">
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              "th, td": {
                textAlign: "center",
              },
            }}
          >
            <Thead>
              <Tr>
                <Th>Book</Th>
                <Th>Name</Th>
                <Th>Author</Th>
                <Th>Publisher</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((issue) => (
                  <Tr key={issue.id}>
                    <Td>{issue.title}</Td>
                    <Td>{issue.member_name}</Td>
                    <Td>{issue.book_author}</Td>
                    <Td>{issue.publisher}</Td>
                    <Td>
                      <Button
                        size="sm"
                        colorScheme="red"
                        onClick={() => handleOpenModal(issue)}
                      >
                        Confirm Return
                      </Button>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="5" textAlign="center">
                    No issues found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>
      </Box>

      <Flex justify="end" align="center" className="sb2" p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>

        <Stack direction="row" spacing={2} mx={2}>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              colorScheme={currentPage === i + 1 ? "teal" : "gray"}
            >
              {i + 1}
            </Button>
          ))}
        </Stack>

        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaList} boxSize={5} mr={2} />
            Return Details
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            {selectedIssue ? (
              <>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                  <FormControl mb={4}>
                    <FormLabel>
                      {" "}
                      <Icon as={FaUser} mr={1} color="teal.500" />
                      Name
                    </FormLabel>
                    <Input
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={selectedIssue.member_name || "N/A"}
                      isReadOnly
                    />
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel>
                      {" "}
                      <Icon as={FaBook} mr={1} color="teal.500" />
                      Book Name
                    </FormLabel>
                    <Input
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={selectedIssue.title || "N/A"}
                      isReadOnly
                    />
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel>
                      {" "}
                      <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                      Due Date
                    </FormLabel>
                    <Input
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={selectedIssue.due_date || "N/A"}
                      isReadOnly
                    />
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel>
                      {" "}
                      <Icon as={FaMoneyBillAlt} mr={1} color="teal.500" />
                      Fine Amount
                    </FormLabel>
                    <Input
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={
                        selectedIssue.fine_amount > 0
                          ? selectedIssue.fine_amount
                          : "No Fine"
                      }
                      isReadOnly
                    />
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel>
                      {" "}
                      <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                      Issue Date
                    </FormLabel>
                    <Input
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={selectedIssue.issue_date || "N/A"}
                      isReadOnly
                    />
                  </FormControl>
                </SimpleGrid>
              </>
            ) : (
              <p>No issue selected</p> // This will prevent the modal from breaking if selectedIssue is null
            )}
          </ModalBody>

          <ModalFooter>
            <VStack spacing={4} align="center">
              {/* Button for paying the fine */}
              {selectedIssue && selectedIssue.fine_amount > 0 && (
                <Button
                  colorScheme="red"
                  onClick={() => {
                    handleOpenModall();
                    setPayFee(selectedIssue);
                    // handleCloseModal();
                  }}
                >
                  Pay Fine and Return
                </Button>
              )}

              {/* Button for returning the book, only shown when there is no fine */}
              <Button
                bgGradient="linear(to-r, teal.400, teal.600)"
                color="white"
                _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
                onClick={handleReturnBook}
                isDisabled={!selectedIssue}
              >
                Return Book
              </Button>
            </VStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {isModalOpenn && (
        <Modal_Pay_student
          isOpen={isModalOpenn}
          onClose={handleCloseModall}
          // amount={transportInfo.transportFee}
          last={selectedIssue.due_date}
          memberId={selectedIssue.member_id}
          fineeId={selectedIssue.fine_id}
          studentId={selectedIssue.student_id}
          userId={
            selectedIssue.member_type === "Student"
              ? selectedIssue.student_user_id
              : selectedIssue.teacher_user_id
          }
          totalAmount={selectedIssue.fine_amount}
          StudentLedgerId={
            selectedIssue.member_type === "Student"
              ? selectedIssue.student_ledger_id
              : selectedIssue.teacher_ledger_id
          }
          memberType={selectedIssue.member_type}
          Return={Return}
        />
      )}
    </Box>
  );
};

export default Return;
